import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useDeleteConsultationPaymentDue = (consultationId) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error deleting payment");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (paymentEntity) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.delete(
        `${tenantVal}/consultationpaymentdue/delete`,
        { data: paymentEntity }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Payment deleted successfully");

      queryClient.invalidateQueries({ queryKey: ["consultationPaymentsDue"] });
      queryClient.invalidateQueries({ queryKey: ["activeConsultation"] });
      queryClient.invalidateQueries({ queryKey: [consultationId] });
    },
    onError: handleNetworkError,
  });
};
